import { emailApi } from '../api/modules/email.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';

export async function getEmailStatus() {
  if (!USE_API) {
    return { configured: false, sendEnabled: false };
  }
  try {
    return await emailApi.status();
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load email status'));
  }
}

export async function sendTestEmail({ to, cc, subject, body }) {
  if (!USE_API) throw new Error('Send test email requires API mode');
  try {
    return await emailApi.sendTest({ to, cc, subject, body });
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to send test email'));
  }
}
